import Vue from "vue";

const err = (error) => {
    if (error.response) {
        let data = error.response.data
        console.log(error.response.data.message, error.response.status)
        switch (error.response.status) {
            case 403:
                Vue.prototype.$notify.error({title: '系统提示', message: '拒绝访问',offset:50})
                break
            case 500:
                Vue.prototype.$message.error({
                    title: '登录已过期',
                    content: '很抱歉，登录已过期，请重新登录',
                    okText: '重新登录',
                    mask: false,
                    onOk: () => {
                        store.dispatch('Logout').then(() => {
                            window.$cookies.set("token","")
                            window.location.reload()
                        })
                    }
                })
                break
            case 404:
                Vue.prototype.$notify.error({title: '系统提示', message: '很抱歉，资源未找到!',offset:50})
                break
            case 504:
                Vue.prototype.$notify.error({title: '系统提示', message: '网络超时',offset:50})
                break
            case 401:
                Vue.prototype.$notify.error({title: '系统提示', message: data.message,offset:50})
                Vue.prototype.$alert(data.message, '系统提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        window.$cookies.set("token","")
                        console.log(window.location.pathname)
                        if (window.location.pathname==='/login') return
                        window.location.href='/login'
                    }
                }).then(()=>{

                })
                break
            default:
                Vue.prototype.$notify.error({title: '系统提示',message: data.message,})
                break
        }
    }
    return Promise.reject(error)
};

export {
    err
}
